import type { SVGProps } from 'react';

/**
 * Instagram Reel glyph (non-collab) — replicated verbatim from Figma's
 * custom "24 / Reels" icon component (node 575:10599, file
 * 0Vugg58oB0iBf1CxP0CUyp). Not a Phosphor icon. Uses `currentColor` to
 * compose with the white-on-gradient-tile treatment it sits in inside
 * deliverable type cards.
 */
export function InstagramReelIcon({
  size = 18,
  className,
  weight: _weight,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number; weight?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      {...props}
    >
      <path d="M11.1 10.5991C11.3 10.7217 11.3 11.0283 11.1 11.1509L7.95 13.0819C7.75 13.2045 7.5 13.0512 7.5 12.806L7.5 8.94401C7.5 8.6988 7.75 8.54555 7.95 8.66815L11.1 10.5991Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6V12C1.5 14.4853 3.51472 16.5 6 16.5H12C14.4853 16.5 16.5 14.4853 16.5 12V6C16.5 3.51472 14.4853 1.5 12 1.5H6ZM12 3H11.0747L12.4247 5.25H14.9055C14.5725 3.95608 13.3979 3 12 3ZM15 6.75H3V12C3 13.6569 4.34315 15 6 15H12C13.6569 15 15 13.6569 15 12V6.75ZM3.09451 5.25H6.17536L4.94077 3.19235C4.03537 3.5341 3.33871 4.30123 3.09451 5.25ZM7.92464 5.25H10.6755L9.32546 3H6.57464L7.92464 5.25Z" fill="currentColor" />
    </svg>
  );
}
